import { useQuery } from "@tanstack/react-query";

import { enterItineraryBudget } from "../repo/quoteBudgetRepo";

/**
 * 进入核价预算运行时：调用 enter 取得或创建当前版本.
 *
 * enter 接口幂等：已有最新版本则返回该版本，仅在无版本时创建.
 * @param itineraryId 行程标识
 */
export function useQuoteBudgetEntryRedirect(itineraryId: string | undefined) {
  return useQuery({
    queryKey: ["quoteBudgetEnter", itineraryId],
    queryFn: () => enterItineraryBudget(itineraryId as string),
    enabled: Boolean(itineraryId),
    retry: false,
  });
}
